/**
 * src/utils/orderUtils.js
 * Utilitários para classificação, validação e auditoria de pedidos de produção.
 */

/**
 * Verifica se um pedido ou identificador é uma solicitação de produção interna para estoque
 * (ex: gerado para moldes de borracha, gaveta de cera ou reposição de estoque de fábrica),
 * garantindo que NÃO seja contabilizado como venda / faturamento a cliente.
 * 
 * @param {Object|string} orderOrNum Registro do pedido ou string de identificação
 * @returns {boolean} True se for solicitação interna de estoque
 */
export function checkIsSolicitacaoEstoque(orderOrNum) {
  if (!orderOrNum) return false;

  // Se passou apenas string (ex: número do pedido ou customerName)
  if (typeof orderOrNum === "string") {
    const s = orderOrNum.trim().toUpperCase();
    return s.startsWith("EST-") || s.includes("SOLICITACAO-ESTOQUE") || s.includes("SOLICITAÇÃO-ESTOQUE");
  }

  // 1. Checa número do pedido (ex: EST-14102026195512)
  const orderNum = String(
    orderOrNum.order_number ||
    orderOrNum.orderNumber ||
    orderOrNum.order?.number ||
    orderOrNum.full_data?.order?.number ||
    orderOrNum.full_data?.orderNumber ||
    ""
  ).trim().toUpperCase();

  if (orderNum.startsWith("EST-") || orderNum.includes("SOLICITACAO-ESTOQUE") || orderNum.includes("SOLICITAÇÃO-ESTOQUE")) {
    return true;
  }

  // 2. Checa nome do cliente
  const customer = String(
    orderOrNum.customer_name ||
    orderOrNum.customerName ||
    orderOrNum.order?.customer?.name ||
    orderOrNum.full_data?.customer_name ||
    orderOrNum.full_data?.order?.customer?.name ||
    orderOrNum.order?.customer ||
    ""
  ).trim().toLowerCase();

  if (
    customer === "solicitacao-estoque" ||
    customer === "solicitação-estoque" ||
    customer.includes("solicitacao-estoque") ||
    customer.includes("solicitação-estoque")
  ) {
    return true;
  }

  // 3. Checa origem nos specs ou full_data
  const specs = orderOrNum.specs || orderOrNum.full_data?.specs || {};
  const origem = String(specs.origem || orderOrNum.full_data?.origem || "").trim().toLowerCase();
  if (origem === "solicitacao_estoque" || origem === "subestoque_cera") {
    return true;
  }

  // 4. Checa flag explícita de solicitação de estoque
  if (orderOrNum.isStockRequest || orderOrNum.full_data?.isStockRequest) {
    return true;
  }

  return false;
}
